import { TagManager } from '../../../../trillion-common/src/tag-manager/TagManager'
import { ViteEnvString } from '../types/vite-env'
import { ViewerGTMEvents } from './viewer-gtm-events'

export function initializeGTM(): boolean {
  const gtmId = import.meta.env.VITE_GTM_ID as ViteEnvString
  const dataLayerName = import.meta.env.VITE_GTM_DATA_LAYER_NAME as ViteEnvString
  const specifiedServerContainer = import.meta.env.VITE_GTM_SERVER_CONTAINER_PATH as ViteEnvString

  if (gtmId && dataLayerName && specifiedServerContainer) {
    // NOTE: check is TagManager with the same dataLayerName already have been initialized on this page
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!window[dataLayerName]) {
      TagManager.initialize({
        gtmId,
        events: ViewerGTMEvents,
        dataLayerName,
        specifiedServerContainer,
      })
    }
    return true
  }
  return false
}
